import React, { useContext } from "react";
import SocialMediaIcons from "./SocialMediaIcons";
import ColumnFooter from "./Column";
import BadgeStores from "./BadgeStores";
import SecurityIcons from "./SecurityIcons";
import EssentialLinks from "./EssentialLinks";
import { FooterContext } from "@contexts/FooterContext";

const FooterDesktop: React.FC = () => {
  const { logo, onClick, column } = useContext(FooterContext);

  const textSimplePractice = `Proudly made in Santa Monica, CA © ${new Date().getFullYear()} SimplePractice, LLC`;

  return (
    <div className="max-w-[1280px] mx-auto lg:mx-10 md:hidden">
      <div className="grid grid-cols-[auto_auto] justify-between pb-[134px] gap-x-8">
        <div className="pb-12">
          <div className="pb-12">
            <a
              href={
                logo?.imageLink?.page?.value?.data?.url || logo?.imageLink?.url
              }
              onClick={onClick}
            >
              <img
                src={logo?.image}
                alt={logo?.imageAltText}
                className="w-[48px] h-[45.474px]"
              />
            </a>
          </div>
          <SocialMediaIcons />
        </div>
        <div>
          <div
            className={`grid gap-6`}
            style={{ gridTemplateColumns: `repeat(${column?.length}, 1fr)` }}
          >
            {column?.map((item, key) => {
              const isLast = key === column?.length - 1;

              return <ColumnFooter key={key} isLast={isLast} item={item} />;
            })}
          </div>
        </div>
      </div>
      <div className="w-full flex justify-between gap-60 pb-6">
        <BadgeStores />
        <SecurityIcons />
      </div>
      <div className="w-full flex justify-between gap-3">
        <div>
          <p className="body--text-small">{textSimplePractice}</p>
        </div>
        <EssentialLinks />
      </div>
    </div>
  );
};

export default FooterDesktop;
